import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Reveal from "@/components/Reveal";
import { WHATSAPP_URL } from "@/components/WhatsAppButton";

const CTABand = ({ title = "Begin with a private conversation.", subtitle, testid = "cta-band" }) => (
  <section className="relative py-24 overflow-hidden grain" data-testid={testid}>
    <div className="absolute inset-0 bg-gradient-to-b from-[#0B0C10] via-[#0E382B]/25 to-[#0B0C10]" />
    <div className="relative max-w-4xl mx-auto px-6 text-center">
      <Reveal>
        <p className="eyebrow mb-5">Private Consultation</p>
        <h2 className="font-display text-4xl sm:text-5xl font-light text-[#F4F3EF] leading-tight mb-6">{title}</h2>
        <p className="text-[#9DA3AE] font-light max-w-xl mx-auto mb-10">
          {subtitle ||
            "Speak directly with the ACRE advisory team about your plans — destinations, budgets, timing and the opportunities that genuinely fit."}
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/private-consultation"
            data-testid={`${testid}-consultation-button`}
            className="inline-flex items-center justify-center gap-2 text-sm uppercase tracking-[0.14em] font-semibold px-8 py-4 rounded-full text-[#0B0C10] bg-gradient-to-r from-[#E6CA65] via-[#C5A880] to-[#9A7B4F] hover:shadow-[0_0_28px_rgba(197,168,128,0.5)] transition-shadow duration-300"
          >
            Book a Private ACRE Consultation <ArrowRight size={16} />
          </Link>
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={`${testid}-whatsapp-button`}
            className="inline-flex items-center justify-center gap-2 text-sm uppercase tracking-[0.14em] font-semibold px-8 py-4 rounded-full border border-[rgba(197,168,128,0.4)] text-[#E6CA65] hover:bg-[rgba(197,168,128,0.08)] transition-colors duration-300"
          >
            WhatsApp +971 58 586 2273
          </a>
        </div>
      </Reveal>
    </div>
  </section>
);

export default CTABand;
